import React from 'react';
import PropTypes from 'prop-types';
import {dashboardService} from '../../../../../store/services';
import UserRoleMetricDisplayInfo from "../../../components/UserRoleMetrics/UserRoleMetricDisplayInfo";
import UserRoleMetrics from "../../../components/UserRoleMetrics/UserRoleMetrics";

const CompanyUserRoleMetrics = props => {
  const { className, metrics, ...rest } = props;

  const displayedRoleList = [
    UserRoleMetricDisplayInfo.companyAdmin,
    UserRoleMetricDisplayInfo.user,
    UserRoleMetricDisplayInfo.viewOnly,
    UserRoleMetricDisplayInfo.inactive
  ];

  return (
    <UserRoleMetrics
      className={className}
      metrics={metrics}
      displayedRoleList={displayedRoleList}
      getRoleMetricsMethod={dashboardService.getUserRoleMetrics}
      {...rest}
    />
  );
};

CompanyUserRoleMetrics.propTypes = {
  className: PropTypes.string
};

export default CompanyUserRoleMetrics;
